import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ParallaxProvider } from "react-scroll-parallax";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ScrollToTop from "./helpers/topScroller";

import { Provider } from "react-redux";
import store from "./store";

// index.html carries fallback meta tags (data-default) for pages that were not
// prerendered. Each page sets its own through <Seo>, so drop the fallbacks first.
document
  .querySelectorAll("head [data-default]")
  .forEach((el) => el.parentNode.removeChild(el));

ReactDOM.render(
  <HelmetProvider>
    <BrowserRouter>
      <Provider store={store}>
        <ParallaxProvider>
          <ScrollToTop />
          <App />
        </ParallaxProvider>
      </Provider>
    </BrowserRouter>
  </HelmetProvider>,
  document.getElementById("root")
);

// Prerendered pages copy CSS-in-JS rules into the markup; the app has inserted its own now.
document
  .querySelectorAll("style[data-prerender-css]")
  .forEach((el) => el.parentNode.removeChild(el));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
